export enum CardType {
  ProductCard = 1,
  Template = 2,
}
